(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const money = cents => new Intl.NumberFormat('tr-TR', {maximumFractionDigits:2}).format(cents/100) + ' TL';
  const drawer = document.querySelector('#CartDrawer');
  const cartContent = drawer?.querySelector('[data-cart-content]');
  const cartError = drawer?.querySelector('[data-cart-error]');
  const form = document.querySelector('#SarilProductForm');
  const el = (tag, cls, text) => { const node=document.createElement(tag); if(cls)node.className=cls; if(text!==undefined)node.textContent=text; return node; };
  async function request(path, body) {
    const res=await fetch(root+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:body?JSON.stringify(body):undefined});
    const data=await res.json(); if(!res.ok)throw new Error(data.description||data.message||'İşlem tamamlanamadı. Lütfen tekrar deneyin.'); return data;
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
    cartContent.replaceChildren(); cartError.textContent='';
    if(!cart.items.length){const box=el('div','empty-cart');box.append(el('h3','','Sepetiniz henüz boş.'),el('p','','Rahatlığı yanınıza almak için Sarıl Yastık’ı keşfedin.'));const a=el('a','btn','Ürünü keşfet');a.href=root+'products/saril-yastik';box.append(a);cartContent.append(box);return;}
    for(const item of cart.items){
      const row=el('article','drawer-row');
      if(item.image){const img=el('img');img.src=item.image;img.alt=item.product_title;img.width=76;img.height=92;row.append(img);}
      const content=el('div');const title=el('h3','',item.product_title);content.append(title,el('p','',item.variant_title||''),el('p','',money(item.final_line_price)));
      const qty=el('div','quantity');
      for(const [label,delta] of [['−',-1],['+',1]]){const b=el('button','',label);b.type='button';b.setAttribute('aria-label',delta===1?'Paket sayısını artır':'Paket sayısını azalt');b.dataset.changeKey=item.key;b.dataset.quantity=String(item.quantity+delta);qty.append(b);if(delta===-1)qty.append(el('span','',String(item.quantity)));}
      const remove=el('button','remove','Kaldır');remove.type='button';remove.dataset.changeKey=item.key;remove.dataset.quantity='0';qty.append(remove);content.append(qty);row.append(content);cartContent.append(row);
    }
    const summary=el('div','drawer-summary');const total=el('div');total.append(el('span','','Toplam'),el('strong','',money(cart.total_price)));const shipping=el('div');shipping.append(el('span','','Kargo'),el('strong','','Ücretsiz'));summary.append(total,shipping,el('p','fine','Adet seçimi paket sayısıdır. 2 Adet paketten 1 seçim, 2 yastık içerir.'));
    const checkout=el('form');checkout.action=root+'cart';checkout.method='post';const b=el('button','btn full','Ödemeye geç →');b.type='submit';b.name='checkout';checkout.append(b);summary.append(checkout,el('p','fine','Teslimden itibaren 30 gün içinde iade başvurusu.'));cartContent.append(summary);
  }
  async function openCart(){drawer.showModal();cartContent.textContent='Sepet yükleniyor…';try{renderCart(await request('cart.js'));}catch(e){cartContent.textContent='';cartError.textContent=e.message+' Sepet sayfasından devam edebilirsiniz.';}}
  document.querySelectorAll('[data-open-cart]').forEach(a=>a.addEventListener('click',e=>{if(!drawer?.showModal)return;e.preventDefault();openCart();}));
  document.querySelector('[data-close-cart]')?.addEventListener('click',()=>drawer.close());
  drawer?.addEventListener('click',e=>{if(e.target===drawer){const r=drawer.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)drawer.close();}});
  let changing=false;
  cartContent?.addEventListener('click',async e=>{const b=e.target.closest('[data-change-key]');if(!b||changing)return;changing=true;cartError.textContent='';cartContent.querySelectorAll('button').forEach(x=>x.disabled=true);try{renderCart(await request('cart/change.js',{id:b.dataset.changeKey,quantity:Number(b.dataset.quantity)}));}catch(err){cartError.textContent=err.message;cartContent.querySelectorAll('button').forEach(x=>x.disabled=false);}finally{changing=false;}});
  const variantSelect = form?.querySelector('select[name=id]');
  if (variantSelect) {
    form.classList.add('sy-enhanced');
    form.addEventListener('change', event => {
      if (event.target.matches('input[name=sy_pack]')) {
        variantSelect.value = event.target.value;
        variantSelect.dispatchEvent(new Event('change', {bubbles:true}));
        return;
      }
      if (event.target !== variantSelect) return;
      const option = [...form.querySelectorAll('input[name=sy_pack]')].find(input => input.value === variantSelect.value);
      if (!option) return;
      option.checked = true;
      document.querySelectorAll('[data-price]:not(input)').forEach(node => node.textContent = money(Number(option.dataset.price)));
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    });
  }

  let purchasing = false;
  const purchaseButtons = [...document.querySelectorAll('[data-add]')];
  function setPurchaseBusy(busy) {
    purchasing = busy;
    form?.setAttribute('aria-busy', String(busy));
    const unavailable = variantSelect?.selectedOptions[0]?.disabled || false;
    purchaseButtons.forEach(button => { button.disabled = busy || unavailable; });
  }
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    if (purchasing) return;
    const option = form.querySelector('input[name=sy_pack]:checked');
    if (!option || option.disabled) return;
    const error = form.querySelector('.form-error');
    error.hidden = true;
    setPurchaseBusy(true);
    try {
      await request('cart/add.js', {items: [{id: Number(option.value), quantity: 1}]});
      await openCart();
    } catch (err) {
      error.textContent = err.message;
      error.hidden = false;
    } finally {
      setPurchaseBusy(false);
    }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) setPurchaseBusy(false);
  });
  const galleryButtons=[...document.querySelectorAll('[data-gallery]')];
  let galleryIndex=0;
  function selectImage(index){if(!galleryButtons.length)return;galleryIndex=(index+galleryButtons.length)%galleryButtons.length;document.querySelectorAll('[data-slide]').forEach(n=>n.hidden=Number(n.dataset.slide)!==galleryIndex);galleryButtons.forEach((n,i)=>n.setAttribute('aria-pressed',String(i===galleryIndex)));const count=document.querySelector('[data-gallery-counter]');if(count)count.textContent=(galleryIndex+1)+' / '+galleryButtons.length;}
  galleryButtons.forEach((b,i)=>b.addEventListener('click',()=>selectImage(i)));
  document.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>selectImage(galleryIndex-1));
  document.querySelector('[data-gallery-next]')?.addEventListener('click',()=>selectImage(galleryIndex+1));
  const galleryMain = document.querySelector('.sy-product-layout .gallery-main');
  if ('IntersectionObserver' in window && document.querySelector('.sy-product-layout')) {
    for (const [selector, className, margin] of [['#SarilProductForm', 'sy-purchase-visible', '0px'], ['#SarilProductForm [data-add]', 'sy-buy-actions-visible', '0px 0px -90px 0px'], ['#SarilReviewForm', 'sy-review-visible', '0px']]) {
      const target = document.querySelector(selector);
      if (target) new IntersectionObserver(entries => {
        document.body.classList.toggle(className, entries[0].isIntersecting);
      }, {rootMargin:margin}).observe(target);
    }
  }
  let touchStart = null;
  galleryMain?.addEventListener('touchstart', event => {
    if (event.touches.length !== 1 || event.target.closest('button')) { touchStart = null; return; }
    touchStart = {x: event.touches[0].clientX, y: event.touches[0].clientY};
  }, {passive:true});
  galleryMain?.addEventListener('touchend', event => {
    if (!touchStart || !event.changedTouches.length) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) selectImage(galleryIndex + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, {passive:true});
  galleryMain?.addEventListener('touchcancel', () => { touchStart = null; }, {passive:true});
  galleryMain?.addEventListener('keydown', event => {
    if (event.target !== galleryMain) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      selectImage(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  const videos=[...document.querySelectorAll('video')];
  videos.forEach(video=>{
    const frame=video.closest('.video-frame');
    video.addEventListener('play',()=>{videos.forEach(other=>{if(other!==video)other.pause();});frame?.classList.add('is-playing');});
    for(const event of ['pause','ended'])video.addEventListener(event,()=>frame?.classList.remove('is-playing'));
    frame?.querySelector('[data-video-play]')?.addEventListener('click',()=>{video.play().catch(()=>{frame.classList.remove('is-playing');});});
  });
  document.querySelectorAll('[data-video-track]').forEach(track=>{
    const section=track.closest('.video-section');const previous=section.querySelector('[data-video-prev]');const next=section.querySelector('[data-video-next]');const position=section.querySelector('[data-video-position]');const cards=[...track.children];
    function status(){if(!cards.length)return;const first=Math.max(0,Math.round(track.scrollLeft/(cards[0].getBoundingClientRect().width+12)));const visible=innerWidth<=749?Number(track.dataset.mobileVisible||2):3;position.textContent=(first+1)+'–'+Math.min(cards.length,first+visible)+' / '+cards.length;previous.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;}
    function move(direction){track.scrollBy({left:direction*(cards[0].getBoundingClientRect().width+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    previous?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));track.addEventListener('scroll',status,{passive:true});track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'){e.preventDefault();move(1);}if(e.key==='ArrowLeft'){e.preventDefault();move(-1);}});new ResizeObserver(status).observe(track);status();
  });
  window.addEventListener('pageshow',e=>{if(e.persisted)request('cart.js').then(cart=>document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count)).catch(()=>{});});
})();


